<script>
    import LyColor from '../components/LyColor.svelte';
    import groupDefinitions from '../../../data/groups.json';

    /** @param {string} group */
    function getGroupDef(group) {
        return groupDefinitions[/** @type {keyof typeof groupDefinitions} */ (group)];
    }

    /**
     * @type {{
     *     tag?: string,
     *     group?: string,
     * }}
     */
    let { tag = 'div', group = '' } = $props();

    const thisGroup = $derived(getGroupDef(group));
</script>

<LyColor {tag} color={thisGroup.color} label={thisGroup.description || '-'} />
